module.exports = __webpack_public_path__ + "/login_ui/img/bs-3d9b9dc7f16420a51596165e49782c59.svg";